import { ReactNode } from 'react'
import { styled } from '@material-ui/core/styles'
import {
  spacing,
  SpacingProps,
  sizing,
  SizingProps,
  compose,
} from '@material-ui/system'

export type SpacingBoxProps = SpacingProps &
  SizingProps & {
    children?: ReactNode | ReactNode[]
    className?: string
  }

// Create a styled div component that uses compose() to handle sizing and spacing
const StyledDiv = styled('div')(compose(spacing, sizing))

// Create the SpacingBox component
const SpacingBox = ({ children, ...props }: SpacingBoxProps) => {
  return <StyledDiv {...props}>{children}</StyledDiv>
}

export default SpacingBox
